import type { ScaleOrdinal } from 'd3-scale';
import { isUndefined } from 'lodash-es';

import { buildColorRule } from '../../../core/color-rule/builder.js';
import type { LegendItem } from '../../../core/components/legend/categorical/types/legend.js';
import type { ColorRuleProps } from '../../../core/types/color-rule.js';
import { getValidColor } from '../../../core/utils/getValidColor.js';

export const buildCategoricalItemsFromScale = (
  scale: ScaleOrdinal<string, string>,
  colorRules: ColorRuleProps[],
) => {
  const categories = scale.domain();
  const colorRule = buildColorRule(colorRules)(categories, 'categoricalLegend');
  const legendItems: LegendItem[] = [];

  categories.forEach((category) => {
    const color = scale(category);
    if (!isUndefined(color)) {
      legendItems.push({
        id: crypto.randomUUID(),
        color: colorRule.for(category) ?? { Default: getValidColor(color) },
        name: category,
      });
    }
  });

  return legendItems;
};
